import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import {
  ReportingServer,
  vsName as ReportingServerName,
} from "../../reporting/server";

import { vsComponentName as ThreeMachinesComponentsViewsMainName } from "./components/views/main";
import {
  GridConfiguration,
  vsComponentName as RecordGridViewComponentName,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../records/views/recordGridView";
import { vsComponentName as MachineConfigurationEditFormComponentName } from "./components/machineEditForm";
import {
  MachineAndConfigurationThreeRivers,
  MachineThreeRivers,
} from "./models/machine";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../records/forms/formView";
import {
  CloneRecordResponse,
  IServiceResponse,
  ServiceResponse,
} from "../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../records/server/serverUtility";
import { cloneDeep, uniq } from "lodash";
import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../ui/authorizedUiElement";
import { IQService, IScope } from "angular";
import { vsServiceName as MachineDetailTabsServiceName } from "../shared/components/views/machines/detail/tabs";
import { IReportGroup } from "../../reporting/interfaces/IReportGroup";
import {
  CloneAndConversionServiceThreeRivers,
  vsServiceName as CloneAndConversionServiceName,
} from "./services/cloneAndConversionService";
import { vsComponentName as softwareProgramGridComponentName } from "./components/softwareProgramGrid";
import {
  machineConfigurationObjectName,
  machineObjectName,
} from "../shared/names";
import { vsObjectName as typeIdName } from "./configs/machineTypeId";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import { vsComponentName as machineTypeIdEditComponentName } from "./components/views/typeId/edit";
import { vsComponentName as machineTypeIdInfoComponentName } from "./components/views/typeId/info";
import { IRowCommandEventArgs } from "../../records/grids/controller";
import { Record } from "../../records/server/crud";
import { MachineConfigurationThreeRivers } from "./models/machineConfiguration";
import { vsComponentName as machineTypeIdInfoMachineComponentName } from "./components/views/typeId/info/machines";
import { vsComponentName as machineTypeIdInfoMachineEditComponentName } from "./components/views/typeId/info/machines/edit";

export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.machines", {
      url: "machines",
      template: "<ui-view></ui-view>",
      abstract: true,
      resolve: {
        reportGroup: [
          ReportingServerName,
          function (reportingServer: ReportingServer) {
            return reportingServer.getReportGroup("machine").then((rg) => {
              return rg;
            });
          },
        ],
      },
    })
    .state("main.machines.softwareGrid", {
      url: "software",
      component: softwareProgramGridComponentName,
    })
    .state("main.machines.grid", {
      url: "",
      component: ThreeMachinesComponentsViewsMainName,
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          "$state",
          (
            recordGridViewService: RecordGridViewService,
            $state: StateService
          ) => {
            const machineConfigurationGridConfiguration =
              recordGridViewService.getGridConfiguration(
                machineConfigurationObjectName
              );
            const gridConfiguration =
              recordGridViewService.getGridConfiguration(machineObjectName)!;

            gridConfiguration.gridDataSource =
              machineConfigurationGridConfiguration?.gridDataSource;
            gridConfiguration.onAddNew = () => {
              return $state.go("^.add").then(() => {});
            };

            return gridConfiguration;
          },
        ],
      },
    })
    .state("main.machines.add", {
      url: "/add",
      component: MachineConfigurationEditFormComponentName,
      params: {
        modelMachineId: undefined,
        modelMachineConfigurationId: undefined,
      },
      resolve: {
        model: [
          "$stateParams",
          CloneAndConversionServiceName,
          (
            $stateParams: StateParams,
            cloneAndConversionService: CloneAndConversionServiceThreeRivers
          ) => {
            const modelMachineId = $stateParams.modelMachineId;
            const modelMachineConfigurationId =
              $stateParams.modelMachineConfigurationId;

            if (!modelMachineId) {
              return {
                Configuration: { Status: "Floor" },
                Machine: {},
              };
            }

            const cloneConfiguration =
              cloneAndConversionService.getCloneConfiguration(
                modelMachineId,
                modelMachineConfigurationId
              );

            return cloneConfiguration;
          },
        ],
        machineFieldsEditable: [() => true],
        onSubmit: [
          FormViewServiceName,
          MachineDetailTabsServiceName,
          (
              formViewService: FormViewService,
              machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>
            ) =>
            (
              formViewController: FormViewController,
              model: MachineAndConfigurationThreeRivers
            ) =>
              formViewService
                .submitForm<ServiceResponse<MachineThreeRivers>>({
                  formObject: model,
                  formViewController,
                  method: "POST",
                  url: "/api/machines/Machine",
                })
                .then((result) =>
                  machineDetailTabsService.navigateToChildByIndex(0, {
                    machineId: result.Result.Id,
                  })
                ),
        ],
        onCancel: [
          "$state",
          ($state: StateService) => () => $state.go("^.grid"),
        ],
        formTitle: [() => "Add Machine"],
      },
    })
    .state("main.machines.detail", {
      url: "/{machineId:int}",
      template: require("!html-loader!./machineDetail.html").default,
      controller: [
        "$scope",
        "machine",
        "machineConfiguration",
        "reportGroup",
        "allProgressiveCalculatedFields",
        (
          $scope: IScope,
          machine: MachineThreeRivers,
          machineConfiguration: MachineConfigurationThreeRivers,
          reportGroup: IReportGroup,
          allProgressiveCalculatedFields: any
        ) => {
          const s = <any>$scope;
          s.machine = machine;
          s.machineConfiguration = machineConfiguration;
          s.reportGroup = reportGroup;
          s.editSref = ".edit";
          s.getProgressiveCalculatedFields = (machineTypeId: number) =>
            allProgressiveCalculatedFields.find(
              (cf: any) => cf.MachineTypeIdId == machineTypeId
            );
        },
      ],
      resolve: {
        machine: [
          ServerUtilityName,
          "$stateParams",
          function (serverUtility: ServerUtility, $stateParams: StateParams) {
            const machineId = $stateParams["machineId"];
            return serverUtility
              .getById<IServiceResponse<MachineThreeRivers>>({
                url: "/api/machines/Machine",
                id: machineId,
              })
              .then((r) => r.Result);
          },
        ],
        machineConfiguration: [
          "machine",
          (machine: MachineThreeRivers) =>
            machine.Configs?.find((c) => c.CurrentConfiguration),
        ],
        allProgressiveCalculatedFields: [
          ServerUtilityName,
          "machine",
          "$q",
          (serverUtility: ServerUtility, machine: any, $q: IQService) => {
            const typeIdIds = uniq<number>(
              machine?.Configs?.map((c: any) => c.MachineTypeIdId ?? 0).filter(
                (id: number) => id > 0
              )
            );
            return resolveProgressiveCalculatedFields(
              serverUtility,
              typeIdIds,
              $q
            );
          },
        ],
      },
    })
    .state("main.machines.detail.edit", {
      url: "/edit/{machineConfigurationId:int}",
      component: MachineConfigurationEditFormComponentName,
      resolve: {
        model: [
          "machine",
          "$stateParams",
          (machine: MachineThreeRivers, $stateParams: StateParams) => {
            const configurationId = $stateParams.machineConfigurationId;
            const configuration = machine.Configs?.find(
              (c) => c.Id === configurationId
            );

            const modelMachine = cloneDeep(machine);
            delete modelMachine.Configs;

            return {
              Machine: modelMachine,
              Configuration: cloneDeep(configuration),
            };
          },
        ],
        machineFieldsEditable: [() => true],
        onSubmit: [
          FormViewServiceName,
          MachineDetailTabsServiceName,
          "$q",
          (
            formViewService: FormViewService,
            machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>,
            $q: IQService
          ) => {
            return (formViewController: FormViewController, model: any) => {
              const { form } = formViewController;

              const machineId = model.Machine.Id;
              const configurationId = model.Configuration.Id;

              const updatePromises = [
                formViewService.submitForm({
                  formObject: model.Configuration,
                  formViewController: formViewController,
                  method: "PUT",
                  url: `/api/machines/MachineConfiguration/${configurationId}`,
                  validationPrefix: "Configuration",
                }),
              ];

              const anyDirtyMachineFields =
                form
                  .$getControls()
                  .find((f) => f.$name?.startsWith("Machine.") && f.$dirty) !==
                undefined;
              if (anyDirtyMachineFields) {
                updatePromises.push(
                  formViewService.submitForm({
                    formObject: model.Machine,
                    formViewController: formViewController,
                    method: "PUT",
                    url: `/api/machines/Machine/${machineId}`,
                    validationPrefix: "Machine",
                  })
                );
              }

              return $q
                .all(updatePromises)
                .then(() =>
                  machineDetailTabsService.navigateToChildByIndex(
                    0,
                    { machineId },
                    true
                  )
                );
            };
          },
        ],
        onCancel: [
          MachineDetailTabsServiceName,
          "$stateParams",
          (
              machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>,
              $stateParams: StateParams
            ) =>
            () => {
              return machineDetailTabsService.navigateToChildByIndex(0, {
                machineId: $stateParams.machineId,
              });
            },
        ],
        formTitle: [() => "Edit Machine"],
        isConversion: [
          "model",
          (model: MachineAndConfigurationThreeRivers) =>
            model.Configuration.ChangeType === "Conversion",
        ],
      },
    })
    .state("main.machines.typeId", {
      component: RecordGridViewComponentName,
      url: "/typeId",
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(typeIdName),
        ],
        gridDataSource: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.gridDataSource,
        ],
        gridSettings: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.gridSettings,
        ],
        columns: [
          "gridConfiguration",
          ColumnDefinitionServiceName,
          (
            gridConfiguration: GridConfiguration,
            columnDefinitionService: ColumnDefinitionService
          ) => {
            return [
              columnDefinitionService.getLinkColDef({
                headerName: "info",
                iconClass: "fa fa-info-circle text-primary",
                colId: "detail",
                width: 20,
                stateExpression: ".info.redirect({ typeId: data.Id})",
              }),
              columnDefinitionService.getLinkColDef({
                headerName: "edit",
                iconClass: "fa fa-pencil text-primary",
                colId: "edit",
                stateExpression: ".info.edit({ typeId: data.Id})",
              }),
              ...(gridConfiguration.columns ?? []),
            ];
          },
        ],
        defaultSort: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.defaultSort,
        ],
        defaultQuery: [
          () => {
            return {};
          },
        ],
        nameSingular: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.nameSingular,
        ],
        namePlural: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.namePlural,
        ],
        showAddButton: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.showAddButton,
        ],
        showAddButtonPermission: [
          "gridConfiguration",
          (gridConfiguration: GridConfiguration) =>
            gridConfiguration.showAddButtonPermission,
        ],
        onItemCommand: [
          "$state",
          ($state: StateService) => (args: IRowCommandEventArgs<Record>) => {
            switch (args.commandName) {
              case "edit":
                return $state.go(".info.edit", { typeId: args.data.Id });
                break;
              default:
                console.log("no handler for command: " + args.commandName);
                break;
            }
          },
        ],
        onAddNew: [
          "$state",
          ($state: StateService) => [() => $state.go(".add")],
        ],
      },
    })
    .state("main.machines.typeId.add", {
      url: "/create",
      views: {
        "@^.^": {
          component: machineTypeIdEditComponentName,
        },
      },
      params: {
        cloneId: undefined,
      },
      resolve: {
        typeId: [
          "$stateParams",
          ServerUtilityName,
          ($stateParams: StateParams, serverUtility: ServerUtility) => {
            if (!$stateParams.cloneId) {
              return {};
            }
            return serverUtility
              .sendApiRequest<ServiceResponse<CloneRecordResponse<Record>>>({
                method: "GET",
                url: `/api/machines/MachineTypeId/${$stateParams.cloneId}/clone`,
              })
              .then((result) => {
                const typeId = result.Result.Clone;
                typeId.Name = undefined;
                return typeId;
              });
          },
        ],
      },
    })
    .state("main.machines.typeId.info", {
      url: "/{typeId:int}",
      views: {
        "@^.^": { component: machineTypeIdInfoComponentName },
      },
      resolve: {
        typeId: [
          ServerUtilityName,
          "$stateParams",
          (serverUtility: ServerUtility, $stateParms: StateParams) =>
            serverUtility
              .getById({
                url: "/api/machines/MachineTypeId",
                id: $stateParms.typeId,
              })
              .then((r: any) => r.Result),
        ],
        progressiveCalculatedFields: [
          ServerUtilityName,
          "typeId",
          "$q",
          (serverUtility: ServerUtility, typeId: any, $q: IQService) => {
            return resolveProgressiveCalculatedFields(
              serverUtility,
              [typeId.Id],
              $q
            ).then((r) => r[0]);
          },
        ],
      },
    })
    .state("main.machines.typeId.info.redirect", {
      url: "/redirect",
      redirectTo: (transition) => {
        return {
          state: "main.machines.typeId.info.machines",
          params: transition.params(),
        };
      },
    })
    .state("main.machines.typeId.info.machines", {
      url: "/machines",
      component: machineTypeIdInfoMachineComponentName,
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(
              machineConfigurationObjectName
            ),
        ],
      },
    })
    .state("main.machines.typeId.info.machines.edit", {
      url: "/edit",
      views: {
        "@^.^": { component: machineTypeIdInfoMachineEditComponentName },
      },
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService) =>
            recordGridViewService.getGridConfiguration(
              machineConfigurationObjectName
            ),
        ],
        initialSelectedIds: [
          "typeId",
          ServerUtilityName,
          (typeId: Record, serverUtility: ServerUtility) =>
            serverUtility
              .fetchAll<Record>({
                url: "/api/machines/MachineConfiguration",
                query: {
                  MachineTypeIdId: typeId.Id,
                },
              })
              .then((items) => items.map((i) => i.MachineConfigurationId)),
        ],
      },
    })
    .state("main.machines.typeId.info.edit", {
      url: "/edit",
      component: machineTypeIdEditComponentName,
    });
}
routeConfig.$inject = ["$stateProvider"];

function resolveProgressiveCalculatedFields(
  serverUtility: ServerUtility,
  typeIdIds: number[],
  $q: IQService
) {
  return typeIdIds.length > 0
    ? serverUtility
        .sendApiRequest<any>({
          method: "post",
          url: `/api/machines/MachineTypeId/progressiveInfo`,
          data: {
            Ids: typeIdIds,
          },
        })
        .then((r) => r.Result)
    : $q.when([]);
}
